import merge from "lodash/merge";

import { selectThemeFile } from "./index";
import { flagOnOrDevelopment, ROLLOUT_THEMES } from "components/Flag";

import defaultTheme, {
  COLORS as DEFAULT_COLORS,
  ssaTheme as DEFAULT_SSA_THEME,
} from "./themes";

const currentTheme =
  window.localStorage && window.localStorage.getItem("colorTheme");

const currentThemeFile = flagOnOrDevelopment(ROLLOUT_THEMES)
  ? selectThemeFile(currentTheme)
  : {};

// MAIN EXPORT
export default merge(defaultTheme, currentThemeFile.theme);

export const COLORS = merge(DEFAULT_COLORS, currentThemeFile.colors);

export const ssaTheme = merge(DEFAULT_SSA_THEME, currentThemeFile.ssaTheme);
